module.exports = __webpack_public_path__ + "static/img/data-dl.8637c008.png";